import { render, staticRenderFns } from "./BaseTableSortable.vue?vue&type=template&id=d619230e&"
import script from "./BaseTableSortable.vue?vue&type=script&lang=js&"
export * from "./BaseTableSortable.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableSortable.vue?vue&type=style&index=0&id=d619230e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports